export default __webpack_public_path__ + "static/media/CMS_Wallet.5ecb9885.svg";